export default {
  "trans.ticketing.create": "取引（チケット）作成",
  "trans.ticketing.detail": "取引（チケット）詳細",
  "trans.ticketing.edit": "取引（チケット）編集",
  "trans.stand.create": "取引（売店）作成",
  "trans.stand.detail": "取引（売店）詳細",
  "trans.stand.edit": "取引（売店）編集",
  "trans.koisk.title":"取引詳細 / 編集",
  "trans.koisk.search.p":"取引番号を検索",
  "trans.memberID.search.p": "会員番号を検索",
  "trans.koisk.transid":"取引番号",
  "trans.koisk.salesgroup":"売上区分",
  "trans.koisk.paymentName":"お支払い",
  "trans.other.date": "日付",
  "trans.other.transationOther": "取引（その他営業収入）追加",
  "trans.other.coupon": "優待券",
  "trans.other.productName": "商品",
  "trans.other.plsSelectProduct": "商品を選択してください",
  "trans.other.quantity": "數量",
  "trans.other.plsInputQuantity": "数量を入力してください",
  "trans.other.plsInputUnitPrice": "単価を入力してください",
  "trans.other.memberId": "会員番号",
  "trans.other.selectPaymentName": "支払方法を選択してください",
  "trans.other.price": "金額",
  "trans.other.selectPrice": "金額を入力してください",

  "trans.report.zhFirstName":"名（漢字）",
  "trans.report.zhLastName":"姓（漢字）",
  "trans.report.jpFirstName":"名（カタカナ）",
  "trans.report.jpLastName":"姓（カタカナ）",
  "trans.report.paymentMethod":"支払い方式",
  "trans.report.ticketTypeName": "券種",
  "trans.report.scheduleStartTime": "上映日時",

  "trans.report.status.success": "支払い済み",
  "trans.report.status.refunded": "払い戻し済み",
  "trans.report.action.refunded": "払い戻し",
  "trans.report.status.cancel": "取消",
  "trans.report.status.delete": "削除されました",
  "trans.report.status.expired": "期限切れの",
  "trans.report.status.fail" : "失敗",
  "trans.report.status.partial_refunded": "一部返金",
  "trans.report.status.processing": "処理",
  "trans.report.status.pending": "支払待ち",

  "trans.report.taxrate.map.non" : "対象外",
  "trans.report.taxrate.map.zero" : "0%",
  "trans.report.taxrate.map.percenteight" : "8%",
  "trans.report.taxrate.map.percentTen" : "10%",

  "trans.report.version.grouping": "パージョングループ分け表示",
  "trans.report.version.caption": "字幕/吹替",
  "trans.report.version.other.placeholder":"その他バージョン全て",
  "trans.report.version.caption.placeholder": "字幕/吹替全て",
  "trans.report.displaySamePrice": "同じ価格の券種をまとめる",
  "trans.report.unitPrice": "入場料金0円の券種を表示",
  "trans.report.screengrouping": "上映回グループ",
  "trans.report.period":"期間",
  "trans.report.generatedate":"出力日時",
  "trans.report.mobolizenumber": "動員数",
  "trans.report.boxoffice": "興行收入",
  "trans.report.occupyrate": "充足率",
  "trans.report.subtotal": "累計",
  "trans.report.witheldtotal":"計算待ち",

  "trans.report.version2.dub": "吹替",
  "trans.report.version2.none": "なし",
  "trans.report.version2.subtitle": "字幕",

  "report.preSalesDaily.showdate":'上映日',
  "report.preSalesDaily.showtime": "上映時間",
  "report.preSalesDaily.grouping": "区分",

  "trans.log.createTime": "操作日時",
  "trans.log.refund": "払戻",
  "trans.log.transactionFinishTime": "取引日時",
  "trans.log.ticketName": "券種",
  "trans.log.changePeople": "デバイス/担当者",
  "trans.log.mark": "コメント",
  "trans.log.productName": "商品名",
  "trans.log.product": "商品",
  "trans.log.input.placeholder": "検索（ログID、取引番号、商品名など）",
  "trans.report.ticketing.time": "取引日時",
  "trans.report.ticketing.plsInputFilmName": "作品を入力してください",
  "trans.report.ticketing.releaseDate": "上映日",
  "trans.report.ticketing.plsSelectReleaseDate": "上映日を選択してください",
  "trans.report.ticketing.releaseTime": "上映時間",
  "trans.report.ticketing.plsSelectReleaseTime": "上映時間を選択してください",
  "trans.report.ticketing.ticket": "券種/全国共通券/劇場前売券",
  "trans.report.ticketing.plsSelectTicket": "券種/全国共通券/劇場前売券を選択してください",
  "trans.report.ticketing.plsInputSeatName": "座席を選択してください",
  "trans.report.ticketing.coupon": "優待券",
  "trans.report.ticketing.zhFirstName": "名（漢字）",
  "trans.report.ticketing.zhLastName": "姓（漢字）",
  "trans.report.ticketing.jpFirstName": "名（カタカナ)",
  "trans.report.ticketing.jpLastName": "姓（カタカナ）",
  "trans.report.ticketing.memberNumber": "会員番号",
  "trans.report.ticketing.payMethod": "支払方法",
  "trans.report.ticketing.plsSelectPayMethod": "支払方法を選択してください",
  "trans.report.ticketing.plsSelectComment": "コメントを選択してください",
  "trans.report.ticketing.plsInputTime": "例) 13",
  "trans.report.ticketing.SeatNamePlaceHolder": "例）B6",

  "trans.report.stand.product": "商品",
  "trans.report.stand.plsSelectProduct": "商品を選択してください",
  "trans.report.other.plsInputUnitprice": "単価を入力してください",
  "trans.report.other.plsInputQuanty": "数量を入力してください",
  "trans.report.other.plsInputAmount": "金額を入力してください",
  "trans.report.stand.plsSelectCoupon": "優待券を選択ください",
  "trans.report.ticketing.price": "(チケット券種/全国共通券/劇場前売券金額)",
  "trans.other.transationOtherDetail": "取引（その他営業収入）詳細",

  "report.cinemaDaily.businessDate": "営業日付",
  "report.cinemaDaily.businessMonth": "営業月",
  "report.cinemaDaily.manager": "支配人",
  "report.cinemaDaily.managerMan": "担当者",
  "report.cinemaDaily.headquarter": "本部",
  "report.cinemaDaily.paidMobilization": "有料動員",
  "report.cinemaDaily.freeMobilization": "無料動員",
  "report.cinemaDaily.boxOfficeAmount": "興収",
  "report.cinemaDaily.budgetCompletionRate": "予算達成率",
  "report.cinemaDaily.incidental": "付帯",
  "report.cinemaDaily.professional": "プロ",
  "report.cinemaDaily.goods": "グッズ",
  "report.cinemaDaily.eating": "飲食",
  "report.cinemaDaily.membershipFree": "会費",
  "report.cinemaDaily.advancePaymentDeposit": "前売金預り",
  "report.cinemaDaily.dailyCash": "当日現金",
  "report.cinemaDaily.deposit": "預金",
  "report.cinemaDaily.monthTotal": "月計",
  "report.cinemaDaily.budget": "予算",
  "report.cinemaDaily.monthEndSafeBalance": "月末金庫残高",
  "report.cinemaDaily.budgetDifference": "予算差",
  "report.cinemaDaily.boxOfficeRatio": "対興収付帯比率",
  "report.cinemaDaily.numberByScreen": "スクリーン別上映回数",
  "report.cinemaDaily.screenName": "スクリーン名",
  "report.cinemaDaily.showTime": "回数",

  "report.saleWeekly.allScreen": "スクリーン規格全て",
  "report.saleWeekly.brandName": "会社名",
  "report.saleWeekly.publicWeek": "公開週",
  "report.saleWeekly.submissionDestination": "提出先",
  "report.saleWeekly.classification": "区分",
  "report.saleWeekly.admissionFees": "入場料金",
  "report.saleWeekly.total": "計",
  "report.saleWeekly.weekTotal": "週計",
  "report.saleWeekly.dayTotal": "日計",
  "report.saleWeekly.invitationTotal": "招待券計",
  "report.saleWeekly.monthTotal": "月累計",
  "report.saleWeekly.cumulativeOoxOffice": "興行累計",
  "report.saleWeekly.personnel": "人員",
  "report.saleWeekly.weather": "天気",
  "report.saleWeekly.showTime1": "回",
  "report.saleWeekly.couponVoucher": "クーポン／引換券",
  "report.saleWeekly.chooseMovie": "作品を選択してください",
  "report.saleWeekly.plsChooseMovie": "作品を選んでください",
  "report.accumulated.until": "まで",
  "report.accumulated.total": "一興行計",
  "reprot.accumulated.totalMovie": "合計（作品）",
  "report.ticketSales.allTotal": "合計（全て）",
  "report.shopSale.cost": "仕入値",
  "report.shopSale.taxRate": "税率(内税)",
  "report.shopSale.unitPrice": "売価",
  "report.shopSale.keshang": "売上",
  "report.shopSale.culi": "粗利",
  "report.shopSale.shopSale": "売店売上",
  "report.shopSale.proxy": "委託商品",
  "report.shopSale.shopSale.buy": "買取商品",
  "report.shopSale.subTotal": "商品区分小計",
  "report.shopSale.allTotal": "売店売上合計",
  "report.salesGroup.subTotal": "売上区分小計",
  "report.group.subTotal": "部門小計",
  "report.client.subTotal": "取引先小計",

  "report.ticketSales.mvtkSubTotal": "合計（全国共通券）",
  "report.ticketSales.advanceSubTotal": "合計（劇場前売券）",
  "report.ticketSales.allTotal": "合計（全て）",
  "report.ticketSales.ticketType": "券種種類",

  "trans.report.ticketing.price": "(チケット券種/全国共通券/劇場前売券金額)",
  "trans.other.date": "日付",
  "trans.other.transationOther": "取引（その他営業収入）追加",
  "trans.other.transationOtherDetail": "取引（その他営業収入）詳細",
  "trans.other.coupon": "優待券",
  "trans.other.productName": "商品",
  "trans.other.selectProduct": "商品を選択してください",
  "trans.other.quantity": "數量",
  "trans.other.selectQuantity": "数量を入力してください",
  "trans.other.selectUnitPrice": "単価を入力してください",
  "trans.other.memberId": "会員番号",
  "trans.other.selectPaymentName": "支払方法を選択してください",
  "trans.other.price": "金額",
  "trans.other.selectPrice": "金額を入力してください",
  "trans.box.week": "公開週",
  "trans.box.clientName": "配給",
  "trans.box.displayShowBack": "上映回別表示",
  "trans.box.plsSelectFilm": "作品を選択してください",
  "trans.box.plsSelectSchedule": "上映回を選択してください",
  "trans.box.withoutTicket": "取引のない券種を表示",
  "trans.box.breakDown": "引換券・割引券の内訳を表示",
  "trans.box.witchoutTransactions": "取引のない上映区分を表示",
  "trans.box.freeMobilize": "無料動員",
  "trans.box.adjustMobilize": "調整動員",
  "trans.box.title-period": "興行日報（日／期間）",
  "trans.box.title-back": "興行日報（上映回）",
  "trans.box.scheduleTime": "上映回",
  "tran.box.brandName": "会社名",
  "trans.box.coupon": "クーポン／引換券",
  "trans.box.admissionFee": "入場料金",
  "trans.box.cumulativeDevelopment": "累計興収",
  "trans.box.online": "ネット予約",
  "trans.box.cashTotal": "現金·ｸﾚｼﾞｯﾄ売上合計",
  "trans.box.advanceTotal": "前売券合計",
  "trans.box.mvtk": "全国共通券合計",
  "trans.box.invitation": "招待券合計",
  "tran.box.windowTotal": "窓口合計",
  "tran.box.onlineTotal": "ネット予約合計",
  "trans.box.allTotal": "総合計",
  "trans.history.screeningDate": "上映日時",
  "trans.update.tips": "更新してもよろしいでしょうか？",
  "trans.plsInput.time": "時間を入力してください",
  "trans.plsInput.min": "分を入力してください",
  "trans.plsInput.validTime": "0〜23の範囲で入力してください",
  "trans.plsInput.validMin": "0〜60の範囲で入力してください",
  "trans.gmoOrderId": "GMO PG Order ID",
  "trans.gmoErrMsg": "エラーメッセージ",
  "trans.table.base.refundWarning": "払い戻してもよろしいでしょうか？",
  "trans.table.refundWarning": "こちらは過去の取引ですが、払い戻してもよろしいでしょうか？",
  "trans.table.base.selectRefundItem": "払い戻しするチケットを選択してください",
  "trans.sendEmail": "メール送信状態",
  "trans.userName": "購入者名",
  // "trans.other.date": "日付",
  // "trans.other.transationOther": "取引（その他営業収入）追加",
  // "trans.other.transationOtherDetail": "取引（その他営業収入）詳細",
  // "trans.other.coupon": "優待券",
  // "trans.other.productName": "商品",
  // "trans.other.selectProduct": "商品を選択してください",
  // "trans.other.quantity": "數量",
  // "trans.other.selectQuantity": "数量を入力してください",
  // "trans.other.selectUnitPrice": "単価を入力してください",
  // "trans.other.memberId": "会員番号",
  // "trans.other.selectPaymentName": "支払方法を選択してください",
  // "trans.other.price": "金額",
  // "trans.other.selectPrice": "金額を入力してください",
  "inventory.concession": "コンセックション",
  "inventory.commercial": "物販",
  "inventory.ingredient": "材料",

  "report.soldRateDaily.theater": "シアター",
  "report.soldRateDaily.numberOfSeats": "座席数",
  "report.soldRateDaily.screeningTimeOfGroup": "各上映回グループ別",

  "filmFeePdf.targetTheater": "対象劇場",
  "filmFeePdf.salesAmount": "売上金額",
  "filmFeePdf.rate": "率",
  "filmFeePdf.filmFee": "フィルム料",
  "filmFeePdf.filmFeeTotal": "フィルム料合計",

  // CL
  "CL.breakDownSales": "興収売上内訳表",
  "CL.incidentalTable": "付帯売上内訳表",
  "CL.dateOfAttraction": "对象日",

  "filmFeePdf.boxOffice": "昼",
  "filmFeePdf.morningShow": "モ",
  "filmFeePdf.lateShow": "レイト",
  "filmFeePdf.allNight": "オ",
  "filmFeePdf.special": "特",
  "filmFeePdf.workPlan": "作品計",
  "filmFeePdf.rationMeter": "配給計",
  "filmFeePdf.total": "総合計",
  "filmFeePdf.sums": "総計",

  "filmFee.distributionCompany": "配給会社",
  "filmFee.periodsWithoutTrans": "取引のない期間を表示",
  "filmFee.boxOfficeCateWithoutTrans": "取引のない興行区分を表示",
  "filmFee.targetPeriod.startDate": "対象期間（始日）",
  "filmFee.targetPeriod.endDate": "対象期間（終日）",

  "arriveDaily.saleDay": "販売日",

  "arriveDaily.total.ticketType": "合計（券種）",
  "arriveDaily.total.times": "合計（回）",
  "report.onlinebooking.creditBrands": "カードブランド",
  "report.onlinebooking.creditForwards": "出向会社",
  "report.onlinebooking.total": "決済総額",
  "report.onlinebooking.visitor": "取引数",
  "report.soldRate.checkbox": "上映会グループ分けなし",

  "report.memberShip": "会員報告",
  "report.memberShip.memberType": "会員種類",
  "report.memberShip.windowOnline": "窓口/オンライン",
  "report.memberShip.cinema": "劇場",
  "report.memberShip.createUpdate": "新規/更新",
  "report.memberShip.personNum": "人数",
  "report.memberSHip.personNumTotal": "合計人数",

  "report.memberShipFeeSales": "会費売上",
  "report.memberShipFeeSales.transactionAmount": "取引金額",
  "report.memberShipFeeSales.transactionAmountTotal": "合計金額（新規、更新）",

  "report.memberShipOnlineFeeSales": "会費売上（ネット決済）",
  "report.transaction.joinRenew": "入会/更新",
  "report.onlineReservation.salesTotal": "売上（追加料金を含む）",
  "report.onlineReservation.systemUseFee(excluding tax)": "システム利用料 (税抜)",
  "report.onlineReservation.salesProcessed": "オンライン予約売上の処理数",
  "report.onlineReservation.transactionNumber": "トランザクション数",
  "report.salesProcessed": "売上処理数",
  "report.onlineReservation.cancellationsProcessed": "オンラインキャンセルの処理数",
  "report.allSales": "オンラインの処理数",
  "report.allSales.allTotal": "トランザクション合計数",
  "report.allSales.allTotalFee": "トランザクション処理料(税抜)",
  "report.allSales.salesTotal": "オンライン売上合計処理数",
  "report.allSales.salesTotalFee": "売上処理料(税抜)(税抜)",
  "report.onlineReservation.processingTotal": "処理数合計",
  "report.onlineReservation.bookPerformance": "本興行（枚数、金額）",
  "report.onlineReservation.lateShow": "レイトショー（枚数、金額）",
  "report.onlineReservation.morningShow": "モーニングショー（枚数、金額）",
  "report.onlineReservation.allNight": "オールナイト（枚数、金額）",
  "report.onlineReservation.specialBusiness": "特別興行（枚数、金額）",
  "report.onlineReservation.total": "合計（合計枚数、合計金額）",
  "report.onlineReservation.advanceTicket": "劇場前売券（枚数、金額）",
  "report.onlineReservation.nationTicket": "全国鑑賞券（枚数、金額）",
  "report.onlineReservation.totalAmount": "合計",
  "report.onlineReservation.online": "CMS / ネット予約",
  "report.onlineReservation.PG": "GMO PG / 劇場別明細",
  "report.onlineReservation.card": "カード / 劇場別明細",

  "report.bookingDaily.spec": `
  本帳票は以下の取引集計しています：\n販売日付 → 該当日付（e.g. ４月１日）\n上映日付 → 該当日付以降で上映するの取引（e.g. ４月２日、４月３日、４月４日、それ以降上映）
  `,
  "report.onlinebooking.spec": `
  本帳票は以下の取引集計しています：\n販売日付 → 該当日付範囲内もしくはそれ以前販売した取引（各自上映の販売開始時間によります）\n上映日付 → 該当日付範囲内上映の取引（e.g. ４月１日～４月４日）\n販売経路 → オンライン
  `,
  "discountRuleTemplate.spec": `
  登録済みのスケジュールの中の個別券種で設定したの\n割引規則はリアルタイムで参照するため、\n本ページの割引規則設定の変更（適用本数、割引額\n等々）はリアルタイムで反映します。
  `
};
